import React from 'react';
import { Handle } from 'react-flow-renderer';
import 'react-flow-renderer/dist/style.css';
import './home.css'; // Ensure the correct path to the CSS file
const CustomNode = ({ data,sourcePosition, targetPosition }) => {
  // Fallback image in case of an error
  const fallbackImage = 'path/to/fallback-image.jpg';

  return (
    <div style={{
      border: 'none',  // Remove the default border
      borderRadius: '8px',
      padding: '0',  // Remove default padding
      textAlign: 'center',
      backgroundColor: 'transparent',  // Remove the default background color
      width: '150px',  // Fixed width for the node
      height: '180px', // Fixed height for the node
      display: 'flex',
      flexDirection: 'column',
	  margin: '0 16px',
      justifyContent: 'space-evently', // Distribute space for image and label
    }}>
      {/* Image with fixed size */}
      <img
        src={data.image || fallbackImage} // Use the fallback image if the src fails
        alt={data.label}
        style={{
          width: '100%',
          height: '90px',  // Fixed height for the image to fit within the node
          objectFit: 'cover',
          borderRadius: '8px',
        }}
        onError={(e) => e.target.src = fallbackImage} // Handle errors if image fails to load
      />
      
      {/* Label */}
      <h4 style={{
        margin: '10px 0 5px',
        fontSize: '14px',
        fontWeight: 'bold',
      }}>
        {data.label}
      </h4>

      {/* Handles for node connection */}
      <Handle 
        type="source" 
        position={sourcePosition}
        style={{ right: 0, top: '90px', transform: 'translateX(50%)' }} 
      />

      {/* Target handle at the bottom-left corner */}
      <Handle 
        type="target" 
		position={targetPosition}
        style={{ left: '90px', bottom: '10px', transform: 'translateX(-50%)' }} 
      />
    </div>
  );
};

export default CustomNode;
